const isDiffer = (a, b) => {
    if (a.join('') === b) {
      return false
    }

    return a.join('').replaceAll('\n', '') !== b.replaceAll(' ', '');
}

export default isDiffer;
